import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '@config/app.config';
import { UsersRepository } from '@core/repositories/users.repository';
import { User } from '@shared/interfaces/user';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiUsersRepository implements UsersRepository {
  constructor(public appConfig: AppConfig, public http: HttpClient) {}

  getItems(): Observable<any> {
    return this.http.get(this.appConfig.SERVICES.users.findall.url);
  }

  add(user: User): Observable<any> {
    const data = {
      data: {
        attributes: {
          username: user.name,
          'role-id': user.idRol
        },
        type: 'User'
      }
    };
    return this.http.post(this.appConfig.SERVICES.users.add.url, data);
  }

  edit(user: User): Observable<any> {
    const data = {
      data: {
        attributes: {
          username: user.name,
          'role-id': user.idRol
        },
        type: 'User'
      }
    };
    return this.http.put(
      this.appConfig.SERVICES.users.update.url + '/' + user.id,
      data
    );
  }

  delete(item: any): Observable<any> {
    return this.http.delete(
      this.appConfig.SERVICES.users.delete.url + '/' + item
    );
  }
}
